import type { FinancialStatementPeriodId } from "../types";

/** Builds a period-keyed record with one entry per id. Cast is confined to this helper. */
export const buildPeriodRecord = <TPeriodId extends FinancialStatementPeriodId, TValue>(
	periodIds: readonly TPeriodId[],
	buildValue: (periodId: TPeriodId) => TValue,
): Record<TPeriodId, TValue> =>
	Object.fromEntries(periodIds.map((periodId) => [periodId, buildValue(periodId)])) as Record<
		TPeriodId,
		TValue
	>;

/** Maps an existing period-keyed record. Cast is confined to this helper. */
export const mapPeriodRecord = <TPeriodId extends FinancialStatementPeriodId, TSource, TValue>(
	source: Record<TPeriodId, TSource>,
	mapValue: (periodId: TPeriodId, value: TSource) => TValue,
): Record<TPeriodId, TValue> =>
	buildPeriodRecord(Object.keys(source) as TPeriodId[], (periodId) =>
		mapValue(periodId, source[periodId]),
	);
